import React from 'react'
import { Table, Space, Button, Tooltip, theme } from 'antd'
import { FileTextOutlined, EditOutlined, PrinterOutlined, MailOutlined } from '@ant-design/icons'
import { formatDateTime, formatDiagnosis, formatPatientInfo, getStatusBadge } from '../utils/formatters'
import { hexToRGBA } from '../../../../lib/utils'

const DischargeTable = ({ data, onView }) => {
  const { token } = theme.useToken()

  const columns = [
    {
      title: 'Patient',
      dataIndex: 'patientName',
      key: 'patientName',
      render: (text, record) => formatPatientInfo(text, record.patientId),
      sorter: (a, b) => a.patientName.localeCompare(b.patientName)
    },
    {
      title: 'Department',
      dataIndex: 'department',
      key: 'department',
      sorter: (a, b) => a.department.localeCompare(b.department)
    },
    {
      title: 'Attending Physician',
      dataIndex: 'attendingPhysician',
      key: 'attendingPhysician',
      sorter: (a, b) => a.attendingPhysician.localeCompare(b.attendingPhysician)
    },
    {
      title: 'Diagnosis',
      dataIndex: 'diagnosisList',
      key: 'diagnosisList',
      render: (diagnoses) => formatDiagnosis(diagnoses)
    },
    {
      title: 'Discharge Date',
      dataIndex: 'dischargeDate',
      key: 'dischargeDate',
      render: (date) => formatDateTime(date),
      sorter: (a, b) => new Date(a.dischargeDate) - new Date(b.dischargeDate)
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => getStatusBadge(status)
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (_, record) => (
        <Space size='small'>
          <Tooltip title='View Details'>
            <Button
              icon={<FileTextOutlined style={{ color: token.colorPrimary }} />}
              size='small'
              onClick={() => onView(record)}
              style={{
                background: hexToRGBA(token.colorPrimary, 0.1),
                borderColor: token.colorPrimary
              }}
            />
          </Tooltip>
          <Tooltip title='Edit'>
            <Button
              icon={<EditOutlined style={{ color: token.colorInfo }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorInfo, 0.1),
                borderColor: token.colorInfo
              }}
            />
          </Tooltip>
          <Tooltip title='Print'>
            <Button
              icon={<PrinterOutlined style={{ color: token.colorSuccess }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorSuccess, 0.1),
                borderColor: token.colorSuccess
              }}
            />
          </Tooltip>
          <Tooltip title='Send as PDF'>
            <Button
              icon={<MailOutlined style={{ color: token.colorWarning }} />}
              size='small'
              style={{
                background: hexToRGBA(token.colorWarning, 0.1),
                borderColor: token.colorWarning
              }}
            />
          </Tooltip>
        </Space>
      )
    }
  ]

  return <Table columns={columns} dataSource={data} rowKey='dischargeId' pagination={{ pageSize: 10 }} />
}

export default DischargeTable
